import { useQuery } from '@tanstack/react-query';
import { Card, StatCard } from '@getpay93/ui';
import { useRevenueMonthly } from '../../data/hooks';
import { api } from '../../lib/api';
import { AreaChart } from '../../components/AreaChart';
import { money, shortDate } from '../../lib/format';

export function Ingresos() {
  const revenue = useRevenueMonthly(6);
  const payments = useQuery({ queryKey: ['payments', 'recent'], queryFn: () => api.payments.list({}) });
  const points = (revenue.data ?? []).map((r) => ({ label: r.month, value: r.amount }));
  const total = points.reduce((s, p) => s + p.value, 0);

  const byMethod = new Map<string, number>();
  for (const p of payments.data ?? []) {
    const k = p.method ?? 'otro';
    byMethod.set(k, (byMethod.get(k) ?? 0) + p.amount);
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
        <StatCard label="Total 6 meses" value={money(total)} tone="green" icon="trending-up" />
        <StatCard label="Este mes" value={money(points.at(-1)?.value)} tone="green" icon="banknote" />
        <StatCard label="Pagos registrados" value={String(payments.data?.length ?? 0)} tone="default" icon="receipt" />
      </div>

      <Card>
        <strong style={{ color: 'var(--text-strong)' }}>Ingresos por mes</strong>
        <div style={{ marginTop: 12 }}><AreaChart points={points} /></div>
      </Card>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16 }}>
        <Card>
          <strong style={{ color: 'var(--text-strong)' }}>Por método</strong>
          <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            {[...byMethod.entries()].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                <span style={{ color: 'var(--text-body)', textTransform: 'capitalize' }}>{k}</span>
                <span style={{ color: 'var(--text-muted)' }}>{money(v)}</span>
              </div>
            ))}
            {byMethod.size === 0 ? <span style={{ color: 'var(--text-hint)' }}>Sin pagos.</span> : null}
          </div>
        </Card>
        <Card padding={0}>
          {(payments.data ?? []).map((p) => (
            <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 16px', borderBottom: '1px solid var(--border)', fontSize: 14 }}>
              <span style={{ color: 'var(--text-body)', textTransform: 'capitalize' }}>{p.method ?? 'otro'}</span>
              <span style={{ color: 'var(--text-muted)' }}>{money(p.amount)} · {shortDate(p.paidAt)}</span>
            </div>
          ))}
          {payments.data && payments.data.length === 0 ? <p style={{ padding: 16, color: 'var(--text-hint)' }}>Sin pagos en el rango.</p> : null}
        </Card>
      </div>
    </div>
  );
}
